(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jouri-collection-carousel')) {
    customElements.define('jouri-collection-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.viewport = this.querySelector('[data-carousel-viewport]');
        this.toggle = this.querySelector('[data-carousel-toggle]');
        if (!this.viewport || !this.toggle) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.paused = false;
        this.speed = Number(this.dataset.speed) || 26;
        this.sign = getComputedStyle(this.viewport).direction === 'rtl' ? -1 : 1;
        this.travel = 1;
        this.visible = false;
        this.hovering = false;
        this.dragging = false;
        this.focused = false;
        this.until = performance.now() + 300;
        this.position = Math.abs(this.viewport.scrollLeft);
        this.updateControl();
        this.toggle.hidden = false;
        this.toggle.addEventListener('click', () => {
          this.paused = !this.paused;
          this.updateControl();
        }, { signal });
        this.viewport.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') this.hovering = true;
        }, { signal });
        this.viewport.addEventListener('pointerleave', () => { this.hovering = false; }, { signal });
        this.viewport.addEventListener('pointerdown', () => { this.dragging = true; }, { passive: true, signal });
        const release = () => {
          if (!this.dragging) return;
          this.dragging = false;
          this.until = performance.now() + 4000;
        };
        window.addEventListener('pointerup', release, { passive: true, signal });
        window.addEventListener('pointercancel', release, { passive: true, signal });
        this.viewport.addEventListener('wheel', () => { this.until = performance.now() + 4000; }, { passive: true, signal });
        this.viewport.addEventListener('focusin', () => { this.focused = true; }, { signal });
        this.viewport.addEventListener('focusout', event => { this.focused = this.viewport.contains(event.relatedTarget); }, { signal });
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
        }, { threshold: 0.15 });
        this.observer.observe(this.viewport);
        this.resizeObserver = new ResizeObserver(() => {
          this.position = Math.abs(this.viewport.scrollLeft);
        });
        this.resizeObserver.observe(this.viewport);
        this.tick = time => {
          const dt = Math.min((time - (this.previous || time)) / 1000, 0.05);
          this.previous = time;
          const max = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
          const active = this.visible && !document.hidden && !this.paused && !this.hovering && !this.dragging && !this.focused && time >= this.until && max > 1;
          this.dataset.carouselState = active ? 'running' : 'paused';
          if (active) {
            this.position = Math.max(0, Math.min(max, this.position + this.travel * this.speed * dt));
            this.viewport.scrollLeft = this.sign * this.position;
            if (this.position >= max || this.position <= 0) {
              this.travel *= -1;
              this.until = time + 1200;
            }
          } else {
            this.position = Math.abs(this.viewport.scrollLeft);
          }
          this.frame = requestAnimationFrame(this.tick);
        };
        this.frame = requestAnimationFrame(this.tick);
      }
      updateControl() {
        this.toggle.setAttribute('aria-pressed', String(this.paused));
        this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jouri-customer-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jouri-review-wall')) {
  customElements.define('jouri-review-wall', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      const speed = Math.min(60, Math.max(18, Number(this.dataset.speed) || 32));
      const streams = [...this.querySelectorAll('.jouri-review-wall__stream')];
      const setSpeed = () => {
        streams.forEach(stream => {
          const distance = stream.firstElementChild?.getBoundingClientRect().height;
          if (distance > 0) stream.style.setProperty('--jouri-review-duration', (distance / speed).toFixed(3) + 's');
        });
      };
      this.resizeObserver = new ResizeObserver(setSpeed);
      streams.forEach(stream => this.resizeObserver.observe(stream.firstElementChild));
      setSpeed();
      const button = this.querySelector('button');
      if (!button) return;
      button.addEventListener('click', () => {
        const paused = this.classList.toggle('is-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.querySelector('[data-motion-label]').textContent = paused ? button.dataset.resume : button.dataset.pause;
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jouri-social-moments"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jouri-moments')) {
  customElements.define('jouri-moments', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const track = this.querySelector('.jouri-moments__track');
      const button = this.querySelector('.jouri-motion-toggle');
      const dialog = this.querySelector('dialog');
      const host = this.querySelector('[data-embed-host]');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const originals = [...track.children];
      const sources = originals.map(card => card.querySelector('[data-jouri-video]').href);
      const speed = Math.min(40, Math.max(12, Number(this.dataset.scrollSpeed) || 22)) / 1000;
      const autoDirection = this.getAttribute('dir') === 'rtl' ? -1 : 1;
      let userPaused = false, pointerDown = false, last = 0, interactionUntil = 0, position = 0, loopDistance = 0, visible = false, active = 0, opener;
      if (originals.length > 1) {
        const leading = document.createDocumentFragment();
        const trailing = document.createDocumentFragment();
        originals.forEach(card => {
          [leading, trailing].forEach(group => {
            const copy = card.cloneNode(true);
            copy.removeAttribute('data-shopify-editor-block');
            copy.setAttribute('aria-hidden', 'true');
            copy.setAttribute('data-jouri-copy', '');
            copy.querySelectorAll('a,button').forEach(node => { node.tabIndex = -1; });
            group.append(copy);
          });
        });
        track.prepend(leading);
        track.append(trailing);
        const syncSize = () => {
          const distance = originals[0].offsetLeft - track.firstElementChild.offsetLeft;
          if (distance <= 0) return;
          const phase = loopDistance > 0 ? ((position - loopDistance) % loopDistance + loopDistance) % loopDistance / loopDistance : 0;
          loopDistance = distance;
          position = loopDistance * (1 + phase);
          track.scrollLeft = position;
        };
        this.resizeObserver = new ResizeObserver(syncSize);
        this.resizeObserver.observe(track);
        this.resizeObserver.observe(originals[0]);
        syncSize();
      }
      const loadInstagram = () => {
        if (window.instgrm?.Embeds) return Promise.resolve();
        if (!window.jouriInstagramLoader) window.jouriInstagramLoader = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://www.instagram.com/embed.js';
          script.async = true;
          script.onload = resolve;
          script.onerror = () => { script.remove(); window.jouriInstagramLoader = null; reject(); };
          document.head.append(script);
        });
        return window.jouriInstagramLoader;
      };
      const renderVideo = index => {
        active = (index + sources.length) % sources.length;
        const url = new URL(sources[active]);
        if (!['www.instagram.com','instagram.com'].includes(url.hostname)) return;
        const quote = document.createElement('blockquote');
        quote.className = 'instagram-media';
        quote.dataset.instgrmPermalink = url.href;
        quote.dataset.instgrmVersion = '14';
        const link = document.createElement('a');
        link.href = url.href;
        link.target = '_blank';
        link.rel = 'noopener';
        link.textContent = host.dataset.loading;
        quote.append(link);
        host.replaceChildren(quote);
        this.querySelector('[data-video-original]').href = url.href;
        loadInstagram().then(() => { if (dialog.open) window.instgrm?.Embeds.process(); }).catch(() => { link.textContent = host.dataset.linkLabel; });
      };
      track.addEventListener('click', event => {
        const link = event.target.closest('[data-jouri-video]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        opener = link;
        dialog.showModal();
        renderVideo(sources.indexOf(link.href));
        this.querySelector('[data-close-video]').focus();
      }, options);
      this.querySelector('[data-close-video]').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } }, options);
      dialog.addEventListener('close', () => { host.replaceChildren(); opener?.focus({preventScroll:true}); interactionUntil = performance.now() + 3000; }, options);
      this.querySelector('[data-video-back]').addEventListener('click', () => renderVideo(active - 1), options);
      this.querySelector('[data-video-next]').addEventListener('click', () => renderVideo(active + 1), options);
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; });
      observer.observe(this);
      this.observer = observer;
      const holdInteraction = () => { interactionUntil = performance.now() + 4000; };
      ['wheel', 'touchstart', 'touchmove', 'keydown', 'focusin'].forEach(name => track.addEventListener(name, holdInteraction, { ...options, passive: true }));
      track.addEventListener('pointerdown', () => { pointerDown = true; holdInteraction(); }, options);
      const releasePointer = () => { if (pointerDown) { pointerDown = false; holdInteraction(); } };
      window.addEventListener('pointerup', releasePointer, options);
      window.addEventListener('pointercancel', releasePointer, options);
      const step = direction => { holdInteraction(); const distance = originals[1] ? originals[1].offsetLeft - originals[0].offsetLeft : 290; track.scrollBy({left:direction * distance,behavior:motion.matches ? 'instant' : 'smooth'}); };
      this.querySelector('[data-track-back]').addEventListener('click', () => step(-1), options);
      this.querySelector('[data-track-next]').addEventListener('click', () => step(1), options);
      button.addEventListener('click', () => {
        userPaused = !userPaused;
        button.setAttribute('aria-pressed', String(userPaused));
        button.querySelector('[data-motion-label]').textContent = userPaused ? button.dataset.resume : button.dataset.pause;
      }, options);
      const tick = now => {
        const delta = Math.min(now - (last || now), 40);
        last = now;
        if (loopDistance > 0 && visible && !document.hidden && !dialog.open && !pointerDown && !userPaused && now > interactionUntil) {
          position += delta * speed * autoDirection;
          if (position < loopDistance || position >= loopDistance * 2) position = loopDistance + ((position - loopDistance) % loopDistance + loopDistance) % loopDistance;
          track.scrollLeft = position;
        } else { position = track.scrollLeft; }
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.abort?.abort();
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.querySelector('dialog')?.close();
      this.querySelector('[data-embed-host]')?.replaceChildren();
      this.querySelectorAll('[data-jouri-copy]').forEach(node => node.remove());
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
if (!customElements.get('jouri-collection-auto')) {
  customElements.define('jouri-collection-auto', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.pending = false;
      this.suspended = false;
      this.bypass = false;
      this.scrolled = false;
      this.lastTrigger = window.scrollY;
      this.header = document.querySelector('.site-header');
      this.socialBar = document.querySelector('.jouri-social-bar');
      this.resizeObserver = new ResizeObserver(() => this.updateShortcutOffset());
      [this.header, this.socialBar].filter(Boolean).forEach(el => this.resizeObserver.observe(el));
      this.headerObserver = new MutationObserver(() => this.updateShortcutOffset());
      if (this.header) this.headerObserver.observe(this.header, { attributes: true, attributeFilter: ['class'] });
      this.refresh();
      this.mutations = new MutationObserver(() => this.refresh());
      this.mutations.observe(this, { childList: true, subtree: true });
      window.addEventListener('scroll', () => {
        if (this.bypassAnchor) this.anchorTop = this.bypassAnchor.getBoundingClientRect().top;
        if (this.bypass && this.grid?.getBoundingClientRect().bottom > window.innerHeight + 180) {
          this.bypass = false;
          this.bypassAnchor = null;
          this.lastTrigger = window.scrollY;
        }
        if (Math.abs(window.scrollY - this.lastTrigger) > 160) this.scrolled = true;
        if (!this.frame) this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.check();
        });
      }, { ...options, passive: true });
      this.addEventListener('click', event => {
        const jump = event.target.closest('[data-jouri-community]');
        if (jump) {
          const selector = jump.dataset.jouriCommunity === 'reviews' ? 'jouri-review-wall' : 'jouri-moments';
          const target = document.querySelector(selector);
          if (!target) return;
          this.bypass = true;
          this.scrolled = false;
          this.bypassAnchor = target;
          const offset = (document.querySelector('.jouri-social-bar')?.offsetHeight || 0) + (document.querySelector('.site-header')?.offsetHeight || 0) + 20;
          window.scrollTo({ top: window.scrollY + target.getBoundingClientRect().top - offset, behavior: 'instant' });
          this.anchorTop = target.getBoundingClientRect().top;
          const heading = target.querySelector('h2');
          if (heading) {
            heading.tabIndex = -1;
            heading.focus({ preventScroll: true });
          }
          return;
        }
        if (event.isTrusted && event.target.closest('#gsloadmore')) this.beginLoad();
      }, options);
      document.addEventListener('DOMContentLoaded', () => this.refresh(), options);
    }
    updateShortcutOffset() {
      const socialHeight = this.socialBar?.offsetHeight || 0;
      const headerHeight = this.header?.matches('.site-header--stuck.site-header--opening') ? this.header.offsetHeight : 0;
      const top = socialHeight + headerHeight;
      if (top !== this.shortcutTop) {
        this.shortcutTop = top;
        this.style.setProperty('--jouri-shortcuts-top', `${top}px`);
      }
    }
    refresh() {
      const grid = this.querySelector('.collection-grid__wrapper .grid');
      const count = grid?.querySelectorAll('.grid-product').length || 0;
      if (grid !== this.grid || count < this.count) {
        clearTimeout(this.timer);
        this.pending = false;
        this.suspended = false;
        this.scrolled = false;
        this.bypass = false;
        this.bypassAnchor = null;
        this.lastTrigger = window.scrollY;
      } else if (count > this.count) {
        clearTimeout(this.timer);
        this.pending = false;
        this.suspended = false;
        if (this.bypassAnchor?.isConnected) {
          const delta = this.bypassAnchor.getBoundingClientRect().top - this.anchorTop;
          if (Math.abs(delta) > 1) window.scrollBy({ top: delta, behavior: 'instant' });
        }
      }
      this.grid = grid;
      this.count = count;
      this.querySelectorAll('.jouri-collection-shortcuts').forEach(nav => {
        const reviews = document.querySelector('jouri-review-wall');
        const moments = document.querySelector('jouri-moments');
        nav.hidden = !reviews && !moments;
        nav.querySelector('[data-jouri-community="reviews"]').hidden = !reviews;
        nav.querySelector('[data-jouri-community="videos"]').hidden = !moments;
      });
      this.updateShortcutOffset();
      this.check();
    }
    beginLoad() {
      this.pending = true;
      this.scrolled = false;
      this.suspended = false;
      this.lastTrigger = window.scrollY;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.pending = false;
        this.suspended = true;
      }, 15000);
    }
    check() {
      if (!this.scrolled || this.pending || this.suspended || this.bypass || document.hidden) return;
      const button = this.querySelector('#gsloadmore');
      if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
      const box = button.getBoundingClientRect();
      if (!box.height || !button.getClientRects().length || getComputedStyle(button).visibility === 'hidden') return;
      const top = (document.querySelector('.jouri-social-bar')?.offsetHeight || 0) + (document.querySelector('.site-header--stuck.site-header--opening')?.offsetHeight || 0);
      if (box.top > window.innerHeight + 180 || box.bottom < top) return;
      this.beginLoad();
      button.click();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.mutations?.disconnect();
      this.resizeObserver?.disconnect();
      this.headerObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      clearTimeout(this.timer);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
